import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiBookOpen } from 'react-icons/fi';
import styles from '../Dashboard.module.css';

// The "My Courses" summary card. Extracted VERBATIM from
// DashboardSummaryCards' render.
export default function CoursesSummaryCard({
  enrolledCourses, handleCourseClick, loaded, setShowPreviousCourses, showPreviousCourses,
}) {
  return (
    <motion.div
      className={`${styles.summaryCard} ${styles.coursesCard}`}
      initial={false}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.summaryHeader}>
        <h3 className={styles.summaryTitle}>
          <FiBookOpen size={20} />
          My Courses
        </h3>
        {enrolledCourses.some(course => {
          const isActive = course.is_active === true || course.is_active === 1;
          const hasNoEndDate = !course.end_date || course.end_date === null;
          const endDateInFuture = course.end_date ? new Date(course.end_date) >= new Date() : false;
          return !(isActive && (hasNoEndDate || endDateInFuture));
        }) && (
          <button
            className={styles.togglePreviousButton}
            onClick={() => setShowPreviousCourses(!showPreviousCourses)}
            type="button"
          >
            {showPreviousCourses ? 'Hide Previous Courses' : 'Show Previous Courses'}
          </button>
        )}
      </div>
      <div className={styles.summaryContent}>
        <div className={styles.coursesGrid}>
          {(() => {
            const filteredCourses = enrolledCourses.filter(course => {
              if (showPreviousCourses) return true;
              const isActive = course.is_active === true || course.is_active === 1;
              const hasNoEndDate = !course.end_date || course.end_date === null;
              const endDateInFuture = course.end_date ? new Date(course.end_date) >= new Date() : false;
              return isActive && (hasNoEndDate || endDateInFuture);
            });
            return filteredCourses.length > 0 ? (
              filteredCourses.slice(0, 6).map((course, index) => (
              <motion.div
                key={course.id || `course-${index}`}
                className={styles.courseTile}
                initial={false}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                onClick={() => handleCourseClick(course.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleCourseClick(course.id);
                  }
                }}
              >
                <div className={styles.courseBadge}>
                  {(course.code || course.name || '?').charAt(0).toUpperCase()}
                </div>
                <div className={styles.courseTileInfo}>
                  <h4 className={styles.courseTileName}>{course.name}</h4>
                  <p className={styles.courseTileCode}>{course.code || 'No code'}</p>
                </div>
              </motion.div>
              ))
            ) : loaded ? (
              <div className={styles.emptySummary}>
                <FiBookOpen />
                <p>No courses enrolled yet.</p>
              </div>
            ) : null;
          })()}
        </div>
        {(() => {
          const filteredCourses = enrolledCourses.filter(course => {
            if (showPreviousCourses) return true;
            const isActive = course.is_active === true || course.is_active === 1;
            const hasNoEndDate = !course.end_date || course.end_date === null;
            const endDateInFuture = course.end_date ? new Date(course.end_date) >= new Date() : false;
            return isActive && (hasNoEndDate || endDateInFuture);
          });
          return filteredCourses.length > 6 ? (
            <div className={styles.moduleFooter}>
              <Link
                to="/courses"
                className={styles.footerAction}
              >
                View all courses
              </Link>
            </div>
          ) : null;
        })()}
      </div>
    </motion.div>
  );
}
